"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsonLdMimeType = "application/ld+json";
/**
 * Sends a JSON-LD request to the API.
 */
function fetchJsonLd(url, options) {
    if (options === void 0) { options = {}; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, headers, status, contentType;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, setHeaders(options))];
                case 1:
                    response = _a.sent();
                    headers = response.headers, status = response.status;
                    contentType = headers.get("Content-Type");
                    if (204 === status) {
                        return [2 /*return*/, Promise.resolve({ response: response })];
                    }
                    if (500 <= status || !contentType || !contentType.includes(jsonLdMimeType)) {
                        return [2 /*return*/, Promise.reject({ response: response })];
                    }
                    return [2 /*return*/, response
                            .json()
                            .then(function (body) { return ({ response: response, body: body, document: body }); })];
            }
        });
    });
}
exports.default = fetchJsonLd;
function setHeaders(options) {
    if (!options.headers) {
        return tslib_1.__assign(tslib_1.__assign({}, options), { headers: {} });
    }
    var headers = typeof options.headers === "function" ? options.headers() : options.headers;
    headers = new Headers(headers);
    if (null === headers.get("Accept")) {
        headers.set("Accept", jsonLdMimeType);
    }
    var result = tslib_1.__assign(tslib_1.__assign({}, options), { headers: headers });
    if ("undefined" !== result.body &&
        !(typeof FormData !== "undefined" && result.body instanceof FormData) &&
        null === result.headers.get("Content-Type")) {
        result.headers.set("Content-Type", jsonLdMimeType);
    }
    return result;
}
//# sourceMappingURL=fetchJsonLd.js.map